var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOtherGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Offer Icon / other_gray") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#707784",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E535C",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Offer-Icon-/-other_gray",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.86280742,6.12706311 L10.5867877,8.84719047 C11.3676066,9.62690504 12.6323934,9.62690504 13.4132123,8.84719047 L16.1371926,6.12706311 C16.9198435,5.3476187 16.9207397,4.08128906 16.140244,3.29968791 C16.139894,3.29933737 16.1395438,3.29898697 16.1381431,3.2996872 L13.4142636,0.576000333 C12.6331264,-0.204881547 11.3668736,-0.204881547 10.5857364,0.576000333 L7.86185692,3.2996872 C7.07973028,4.07965765 7.0796855,5.34598761 7.86070646,6.12706381 C7.86105674,6.12741411 7.86140715,6.12776429 7.86280742,6.12706311 Z M15.1498315,13.4164816 L17.873811,16.1404611 C18.6548596,16.9215097 19.9211895,16.9215097 20.7022381,16.1404611 L23.4262177,13.4164816 C24.2071967,12.6354025 24.2072191,11.3691111 23.4262677,10.5880044 L20.7021881,7.86373224 C19.9212672,7.08255604 18.6549372,7.08251126 17.873861,7.86353223 C17.8738277,7.86356556 17.8737943,7.8635989 17.873861,7.86373224 L15.1497815,10.5880044 C14.36883,11.3691111 14.3688524,12.6354025 15.1498315,13.4164816 Z M0.573782344,13.4164816 L3.29776187,16.1404611 C4.07881045,16.9215097 5.34514041,16.9215097 6.12618899,16.1404611 L8.85016852,13.4164816 C9.63114757,12.6354025 9.63116995,11.3691111 8.85021852,10.5880044 L6.12613899,7.86373224 C5.34521803,7.08255604 4.07888808,7.08251126 3.29781188,7.86353223 C3.29777854,7.86356556 3.2977452,7.8635989 3.29781188,7.86373224 L0.573732337,10.5880044 C-0.207219092,11.3691111 -0.207196704,12.6354025 0.573782344,13.4164816 Z M7.86225705,20.7036632 L10.5853363,23.4250092 C11.3671822,24.2045566 12.6328178,24.2045566 13.4146637,23.4250092 L16.1377429,20.7036632 C16.9195401,19.9233636 16.9199432,18.6570337 16.1391433,17.8757365 C16.1389767,17.8755697 16.1388099,17.8754029 16.1381431,17.8757363 L13.4142636,15.1520495 C12.6331264,14.3711676 11.3668736,14.3711676 10.5857364,15.1520495 L7.86185692,17.8757363 C7.0802806,18.6562572 7.08023582,19.9225871 7.86125679,20.7036633 C7.86142352,20.7038301 7.86159029,20.7039968 7.86225705,20.7036632 Z",
    id: "icon",
    fill: "url(#linearGradient-1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherGray);
export default __webpack_public_path__ + "static/media/other_gray.786a3930d60269786e3bee80cbeba4e0.svg";
export { ForwardRef as ReactComponent };